import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is running; otherwise the id of the interview whose `DELETE` is in flight. */
const interviewDeletionInProgressSignal = createSignal<number | null>(null);

export const startInterviewDeletion = (interviewId: number): void => {
	interviewDeletionInProgressSignal.value = interviewId;
};

export const endInterviewDeletion = (): void => {
	interviewDeletionInProgressSignal.value = null;
};

export default interviewDeletionInProgressSignal;
